var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWithdrawSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24.00 24.00",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.152;}.cls-1{stroke-linecap:square;}")), /*#__PURE__*/React.createElement("g", {
    id: "withdrawl"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.5 1.5 22.5 11.04 17.73 11.04 17.73 6.27 6.27 6.27 6.27 11.04 1.5 11.04 1.5 1.5 22.5 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.27,
    y1: 6.27,
    x2: 17.73,
    y2: 6.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.27,
    y: 6.27,
    width: 11.45,
    height: 16.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 2.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.36,
    y1: 6.27,
    x2: 19.64,
    y2: 6.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12,
    y1: 16.77,
    x2: 12,
    y2: 19.64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWithdrawSvgrepoCom);
export default __webpack_public_path__ + "static/media/cash-withdraw-svgrepo-com.119f5d70ab5333a4799300421ffad9d7.svg";
export { ForwardRef as ReactComponent };